<div style="display: flex;width:100%;height:100%;font-family: KantarBrown-Regular;
font-size: 0.75rem;" id="chart-divs">
    <div style="width:97%;height:100%;">

        <div class="container">
            <div class="scroll-container">
                <div *ngFor="let item of items| zip: trendItems;let i = index; trackBy: trackById" class="item" [attr.step]="i">

                    <div class="itemHeader">
                        <p class="itemName">{{ item.item1.widgetName}}</p>
                        <div class="itemIcon">
                            <app-output-icons style="width:100%; display:flex;justify-content: end;" [widgetName]="item.item1.widgetName"
                                [visualization]="item.item1.visualization" [id]="i" [infoIcon]="item.item1.infoIcon"
                                [data]="item.item1.metric" [trendData]="item.item2.metric" [sort]="item.item1.sort" [isSort]="item.item1.isSort" [sortToggleFromParent]="sortToggle"
                                (iconClicked)="ClickedIconFun($event)" [item]="item.item1" (sortType)="sortWidget($event)" (defaultSortType)="defaultSortWidget($event)"></app-output-icons>
                        </div>
                    </div>
                    <hr>
                    <div class="chart-section" style="border: 1px solid #ddd;box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px">
                        <app-snapshot-chartsparent *ngIf="item.item1.metric.length>0 && showChart" [chart]="item.item1.visualization" [id]="i"
                            [data]="item.item1.metric" [height]="height" [sort]="item.item1.sort"></app-snapshot-chartsparent>
                    </div>
                    <div class="chart-section-text" *ngIf="item.item1.metric.length<1">
                        <div *ngIf="item.item1.metric.length<1 && item.item1.noData==undefined">Widget is not configured.</div>
                        <div *ngIf="item.item1.metric.length<1 && item.item1.noData==true">No data available for the selection.</div>
                    </div>
                </div>
            </div>
        </div>


    </div>
    <div style="width:3%;height:100%;" *ngIf="showPageNav">
        <app-outputview-pagination (paginationCounter)="paginationCounterFun($event)"
            [totalPages]="pagesPerSection"></app-outputview-pagination>

    </div>
</div>


<!-- (closeErrorPopUp)="onCloseIconClick($event)" -->